<section id="contact-us">
  <div class="contact-us-box">
    <div class="container">
      <div class="content">
        <div>
          <div class="image-wrap">
            <img src="assets/svgs/contact.svg" alt="Contact us"/>
          </div>
          <div class="info-box">
            <ul>
              <li class="contact-item">
                <img src="assets/svgs/location.svg" alt="Location icon"/>
<!--                <a href="https://www.google.com/maps/search/?api=1&query=YOUR_ADDRESS" target="_blank">-->
                {{"global.address" | translate}}
              </li>
              <li class="contact-item">
                <img src="assets/svgs/phone.svg" alt="Phone icon"/>
                <a href="tel:+359896792874">{{ '+359896792874' }}</a>
              </li>
              <li class="contact-item">
                <img src="assets/svgs/email.svg" alt="Email icon"/>
                <a href="mailto:info@selectivebits.com">{{ 'info@selectivebits.com' }}</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="form">
          <h2 class="section-title">{{"contactUs.title" | translate}}</h2>
          <p class="note">{{"contactUs.note" | translate}}</p>
          <form [formGroup]="formGroup">
            <div class="form-fields">
              <div class="field text">
                <mat-form-field appearance="outline" floatLabel="always">
                  <mat-label>{{"contactUs.name" | translate}}</mat-label>
                  <input matInput formControlName="name"/>
                  <mat-error
                    *ngIf="formGroup.get('name').touched && formGroup.get('name').hasError('required')">{{ "global.required" | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="field  text">
                <mat-form-field appearance="outline" floatLabel="always">
                  <mat-label>{{"contactUs.phone" | translate}}</mat-label>
                  <input formControlName="phone" matInput type="tel"/>
                  <mat-error
                    *ngIf="formGroup.get('phone').touched && formGroup.get('phone').hasError('required')">{{ "global.required" | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="field  text">
                <mat-form-field appearance="outline" floatLabel="always">
                  <mat-label>{{"contactUs.email" | translate}}</mat-label>
                  <input matInput type="email" formControlName="email"/>
                  <mat-error
                    *ngIf="formGroup.get('email').touched && formGroup.get('email').hasError('required')">{{ "global.required" | translate }}
                  </mat-error>

                  <mat-error *ngIf="formGroup.get('email').touched && formGroup.get('email').hasError('email')"
                             class="error-message">
                      {{ "contactUs.notValidEmail" | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="field">
                <mat-form-field appearance="outline" floatLabel="always">
                  <mat-label>{{"contactUs.message" | translate}}</mat-label>
                  <textarea matInput rows="4" formControlName="message"></textarea>
                  <mat-error
                    *ngIf="formGroup.get('message').touched && formGroup.get('message').hasError('required')">{{ 'Required field' }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="field">
                <mat-checkbox formControlName="agreement">{{"contactUs.agree" | translate}}</mat-checkbox>
              </div>

              <div class="actions">
                <button mat-button="filled" style="align-self: flex-start; margin-top: 15px;" class="main"
                        (click)="onSubmit()" [disabled]="loading">Contact us
                </button>
                <div *ngIf="submitted" class="success">
                  <p>{{"contactUs.success" | translate}}</p>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div>
      </div>
    </div>
  </div>
</section>
